import { RegisterVisualization } from '@/modules/feed/domain/model/RegisterVisualization'

import { axios } from '..'

const registerVisualization = (body: RegisterVisualization) => {
  return axios.post('/v1/feed/silent-view', body)
}

export default registerVisualization
